import { html, ref } from '@microsoft/fast-element';
import { sync } from '@genesislcap/foundation-utils';
import type { LmeTotalCarbonReduction } from './lme-total-carbon-reduction';
import { GRAPH_DATA_TYPE, GRAPH_PERIODICITY } from '../../../../../utils/enums/generic.enum';
export const LmeTotalCarbonReductionTemplate = html<LmeTotalCarbonReduction>`
<div class="graph-div">
  <div class="criteria-selection">
        <div class="data-type-control">
          <label class="control-label">Data Type</label>
          <zero-segmented-control
            appearance="primary"
            orientation="horizontal"
            :value="${sync((x) => x.dataType)}"
          >
            <zero-segmented-item value=${GRAPH_DATA_TYPE.HISTORICAL} class="custom-segmented-item">
              Historical
            </zero-segmented-item>
            <zero-segmented-item value=${GRAPH_DATA_TYPE.FORECAST} class="custom-segmented-item">
              Forecast
            </zero-segmented-item>
          </zero-segmented-control>
        </div>
        <div class="periodicity-control">
          <label class="control-label">Periodicity</label>
          <zero-segmented-control
            appearance="primary"
            orientation="horizontal"
            :value="${sync((x) => x.periodicity)}"
          >
            <zero-segmented-item value=${GRAPH_PERIODICITY.MONTHLY} class="custom-segmented-item">
              Monthly
            </zero-segmented-item>
            <zero-segmented-item value=${GRAPH_PERIODICITY.QUATERLY} class="custom-segmented-item">
              Quarterly
            </zero-segmented-item>
            <zero-segmented-item value=${GRAPH_PERIODICITY.YEARLY} class="custom-segmented-item">
              Yearly
            </zero-segmented-item>
          </zero-segmented-control>
        </div>
      </div>
      <div style="height: 100%; display: ${(x) => (x.isVisible ? '' : 'none')}" ${ref(
  'lmeChart'
)}></div>
    </div>
  </div>
</div>
      
`;
